import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getIncomeCollection, generateCollectionReport } from '../AdminActionCreator.component'
import IncomeUi from '../../../presentationals/Admin/DashboardAndReports/IncomeCollected.component'
import { _preFormatDate } from '../../../../utils/validation'
import Loader from '../../../presentationals/Loader/graphloader.component'
import { APIS } from '../../../../utils/api-factory'
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import moment from 'moment'
class Income extends React.Component {
  constructor(props) {
    super(props)
    const { customcommonFilters } = props;
    this.state = {
      loaderState: false,
      incomeData: '',
      FilteredData: [],
      pageIndexToShow: 0,
      startDate: moment(customcommonFilters.fromDate, 'YYYY-MM-DD').format('DD-MM-YYYY'),
      endDate: moment(customcommonFilters.toDate, 'YYYY-MM-DD').format('DD-MM-YYYY'),
      startDateToShow: customcommonFilters.fromDate,   
      endDateToShow: customcommonFilters.toDate, 
    }
  }
  getFilterValue(filtered) {
    this.setState({ FilteredData: filtered })
  }

  getPageValue(pageIndex) {
    this.setState({ pageIndexToShow: pageIndex })
  }
  componentDidMount() {
    this.setState({ loaderState: true })

    getIncomeCollection(this.state.startDate, this.state.endDate, callback => {
      this.setState({ incomeData: callback, loaderState: false })
    })
  }

  componentDidUpdate(prevProps) {
    const { fromDate, toDate } = this.props.customcommonFilters;
    const { fromDate: prevFrom, toDate: prevTo } = prevProps.customcommonFilters;

    if (fromDate !== prevFrom || toDate !== prevTo) {
      const newStartDate = moment(fromDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
      const newEndDate = moment(toDate, 'YYYY-MM-DD').format('DD-MM-YYYY');

     
      if (newStartDate !== this.state.startDate || newEndDate !== this.state.endDate) {
        this.setState({
          startDate: newStartDate,
          endDate: newEndDate,
          startDateToShow: fromDate,
          endDateToShow: toDate,
        }, () => {
          this.setState({ loaderState: true })
          getIncomeCollection(this.state.startDate, this.state.endDate, callback => {
            this.setState({ incomeData: callback, loaderState: false })
          })
        });
      }
    }
  }

  handleChange(e, type) {
    console.log("e",e)
    if (type == 'start') {
      this.setState({
        startDate: _preFormatDate(e),
        startDateToShow: e
      })
      this.props.setCommonFilters({ fromDate: moment(e).format("YYYY-MM-DD") });
    } else if (type == 'end') {
      this.setState({
        endDate: _preFormatDate(e),
        endDateToShow: e
      })
      this.props.setCommonFilters({ toDate: moment(e).format("YYYY-MM-DD") }); 
    }
  }
  GenerateHandler(e) {  
    window.open(APIS.GENERATE_COLLECTION_REPORT + this.state.startDate + '&endDate=' + this.state.endDate);
  }
  submitHandler(e) {
    this.setState({ loaderState: true })
    getIncomeCollection(this.state.startDate, this.state.endDate, callback => {
      this.setState({ incomeData: callback, loaderState: false })
    })
  }
  render() {
    return (
      <div>{this.state.loaderState ? <Loader /> : ""}
        <IncomeUi
          GenerateHandler={this.GenerateHandler.bind(this)}
          incomeData={this.state.incomeData}
          getFilterValue={this.getFilterValue.bind(this)}
          FilteredData={this.state.FilteredData}
          getPageValue={this.getPageValue.bind(this)}
          pageIndexToShow={this.state.pageIndexToShow}
          handleChange={this.handleChange.bind(this)}
          submitHandler={this.submitHandler.bind(this)}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
        />
      </div>
    )
  }
}
const mapStateToProps = ({ FilterReduce }) => {
  return {
    customcommonFilters: FilterReduce.commonFilters
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({}, dispatch),
    setCommonFilters: (payload) => dispatch({ type: FILTER_ACTION, payload })
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Income);
